// BSV CHANGES
import {createSlice, PayloadAction} from '@reduxjs/toolkit';

// interface DownloadItem {
//   endDate: string;
//   startDate: string;
//   selectedReportType: number;
//   ids: number[];
// }

interface ExpenseReportsState {
  loading: boolean;
  data: string[];
  error: string | null;
}

const initialState: ExpenseReportsState = {
  loading: false,
  data: [],
  error: null,
};


const expenseReportsSlice = createSlice({
  name: 'expenseReports',
  initialState,
  reducers: {
    postDownloadRequest: (state, _action: PayloadAction<{ ids: number[]; startDate: string; endDate: string; selectedReportType: number }>) => {
      state.loading = true;
      state.error = null;
    },
    postDownloadSuccess: (state) => {
      state.loading = false;
    },
    postDownloadFailure: (state, action: PayloadAction<string>) => {
      state.loading = false;
      state.error = action.payload;
    },
    HQPositionRequest: (state, _action: PayloadAction<{}>) => {
      state.loading = true;
      state.error = null;
    },
    HQPositionSuccess: (state, action: PayloadAction<any[]>) => {
      state.loading = false;
      state.data = action.payload;   
    },
    HQPositionFailure: (state, action: PayloadAction<string>) => {
      state.loading = false;
      state.error = action.payload;
    },
  },
});

export const expenseReportsDownloadReducer = expenseReportsSlice.reducer;
export const {
  postDownloadRequest,
  postDownloadSuccess,
  postDownloadFailure,
  HQPositionRequest,
  HQPositionSuccess,
  HQPositionFailure
} = expenseReportsSlice.actions;